import { useEffect, useState } from "react";

export function useTypingPlaceholder(text: string, speed = 35) {
  const [display, setDisplay] = useState("");

  useEffect(() => {
    if (!text) {
      setDisplay("");
      return;
    }

    let i = 0;
    setDisplay("");

    // ⏱️ SMALL DELAY to let React flush state
    const startTimeout = setTimeout(() => {
      const timer = setInterval(() => {
        if (i >= text.length) {
          clearInterval(timer);
          return;
        }

        setDisplay(prev => prev + text.charAt(i));
        i++;
      }, speed);

      return () => clearInterval(timer);
    }, 50); // 🔑 THIS fixes first-letter cut

    return () => clearTimeout(startTimeout);
  }, [text, speed]);

  return display;
}
